// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"92f3e404","242":"0fd47207","244":"170bb3d1","413":"1aacc0b8","438":"170bb3d1","523":"1aacc0b8","728":"92f3e404","825":"0fd47207"}[chunkId] + ".chunk.css";
};